import { useContext, createContext } from 'react';

// ----------------------------------------------------------------------

export const ShopContext = createContext(null);

export const useShopContext = () => {
    const context = useContext(ShopContext);

    if (!context) {
        throw new Error('useShopContext must be used within a ShopProvider');
    }

    return context;
};
